import { baseApi } from '@/store/api/base.api';

export const contactApi = baseApi.injectEndpoints({
	endpoints: (builder) => ({
		createContact: builder.mutation<any, { data: any }>({
			query: (body) => ({
				url: `/contacts`,
				method: 'POST',
				body,
			}),
		}),
	}),
	overrideExisting: true,
});

export const { useCreateContactMutation } = contactApi;
